import { SOCIAL_LINKS } from "../../constants/ContactsConstant";
import { Link } from "react-router-dom";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import { SLIDES } from "../../constants/HomeConstant";
import ArrowIcon from "../../common/svg/ArrowIcon";
import VideoSvg from "../../common/svg/VideoSvg";

const Banner = () => {
  return (
    <div className="banner-area3">
      <div className="banner-vector">
        <img
          className="img-fluid"
          src="https://appthing-website.s3.ap-south-1.amazonaws.com/banner-vector.png"
          alt="Banner"
        />
      </div>
      <div className="swiper-pagination1"></div>
      <div className="social-area">
        <ul>
          {SOCIAL_LINKS.map(({ icon, url }) => (
            <li key={url}>
              <Link to={url} target="_blank" rel="noopener noreferrer">
                <i className={icon}></i>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <Swiper
        className="banner3-slider"
        modules={[Autoplay, Pagination]}
        speed={2000}
        effect="fade"
        fadeEffect={{
          crossFade: true,
        }}
        loop={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        spaceBetween={30}
        slidesPerView={1}
        pagination={{
          clickable: true,
          el: ".swiper-pagination1",
        }}
      >
        {SLIDES.map(({ id, title, description, bannerImg }) => (
          <SwiperSlide key={id}>
            <div key={id} className="swiper-slide">
              <div className="banner-wrapper">
                <div className="banner-content">
                  <h1> {title} </h1>
                  <p> {description} </p>
                  <div className="banner-btn-group">
                    <Link className="primary-btn3" to="/contact-us">
                      Contact Us
                    </Link>
                    <Link className="primary-btn4" to="/about">
                      <span>
                        <ArrowIcon width={13} height={13} />
                      </span>
                      Explore More
                    </Link>
                  </div>
                </div>
                <div className="banner-image magnetic-item">
                  <img className="img-fluid" src={bannerImg} alt="Banner" />
                </div>
                <div className="banner-video-area">
                  <div className="video-area">
                    <Link
                      data-fancybox="gallery"
                      className="video-popup"
                      to="https://www.linkedin.com/company/appthing/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <VideoSvg />
                    </Link>
                    <img
                      className="video-img"
                      src="https://appthing-website.s3.ap-south-1.amazonaws.com/home3-banner-video.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Banner;
